'use strict';

import React from 'react';

require('styles/nav/Bar.css');

import InputComponent from '../search/InputComponent'

class BarComponent extends React.Component {
  constructor(props) {
      super(props);
  }

  render() {
    var titleStyle = {
      "fontFamily": 'Orbitron',
      "color": "white",
      "textAlign": "center",
      "fontSize": "2em"
    }
    var smallTitleStyle = {
      "color": "white",
      "margin": 0
    }
    var headerStyle = {
      padding: "1em",
      "border-bottom": "5px ridge whitesmoke"
    }
    var globeStyle = {
      paddingRight:"5px"
    }
    var linkStyle = {
      color: 'white'
    }

    return (
      <div className="container-fluid" style={headerStyle}>
        <nav className="row">
          <div className="col-xs-12 col-lg-2 text-center" >
            <a style={titleStyle}>MetaDroner</a>
            <p style={smallTitleStyle}>
              <a href="https://twitter.com/themetadroner" className="twitter-follow-button" data-show-count="false">Follow @themetadroner</a>
            </p>
            <p style={smallTitleStyle}>
              <span className="glyphicon glyphicon-globe" aria-hidden="true" style={globeStyle}></span>
              <a href="mailto:hello@metadroner.com?Subject=Hello" target="_top" style={linkStyle}>hello@metadroner.com</a>
            </p>
          </div>
          <div className="col-xs-12 col-lg-10">
            <InputComponent searchHandler={this.props.searchHandler} />
          </div>
        </nav>
      </div>
    );
  }
}

BarComponent.displayName = 'NavBarComponent';

// Uncomment properties you need
// BarComponent.propTypes = {};
// BarComponent.defaultProps = {};

export default BarComponent;



/** WEBPACK FOOTER **
 ** ./src/components/nav/BarComponent.js
 **/